import React from 'react';
import './AdminIntro.scss'


const AdminIntro = () => {


    return (
        <div className='admin-intro'>
            <h2>Welcome dd !</h2>
            <p>
                <a href="">LVZConnect</a> / Dashboard
            </p>
        </div>
    )
}

export default AdminIntro